import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'KeyboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2 6m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 10l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 14l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 14l4 .01"
    }, null), _createTextVNode(" ")]);
  }
};